import { IGetAllFolhaPagamentoUseCase } from "../../../presentation/useCases/read/get_all_folha_pagamento_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { FolhaPagamento } from "../../models/folha_pagamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllFolhaPagamentoUseCase
 */

export class GetAllFolhaPagamentoUseCase extends BasePaginatedUseCase<FolhaPagamento> implements IGetAllFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllFolhaPagamento(
    tipoPesquisa: number,
    valorPesquisa: string | null,
    idFuncionario: number | null,
    dataCadastro: Date | null,
    dataPagamento: Date | null,
    numero: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllFolhaPagamento(
      tipoPesquisa,
      valorPesquisa,
      idFuncionario,
      dataCadastro,
      dataPagamento,
      numero,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
